import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentBase } from '@utils/models/PaymentBase';

interface IPaymentData {
  base: PaymentBase;
  bookingId?: number;
  id: number;
  number?: string;
  contractId?: number;
  createdDate?: string;
}

interface ContractState {
  contractId: number | null;
  contractNumber: string | null;
  visible: boolean;
  currentPage: number;
  openDownloadModal: boolean;
  templateData?: { language: string }[];
  paymentData?: IPaymentData;
}

const initialState: ContractState = {
  contractId: null,
  contractNumber: null,
  visible: false,
  currentPage: 1,
  openDownloadModal: false
};

export const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setContractId: (state, action: PayloadAction<number | null>) => {
      state.contractId = action.payload;
    },
    setContractNumber: (state, action: PayloadAction<string | null>) => {
      state.contractNumber = action.payload;
    },
    setVisible: (
      state,
      action: PayloadAction<{
        visible: boolean;
        contractId: number | null;
        contractNumber: string | null;
      }>
    ) => {
      state.visible = action.payload.visible;
      state.contractId = action.payload.contractId;
      state.contractNumber = action.payload.contractNumber;
    },
    setClear: state => {
      state.contractId = null;
      state.contractNumber = null;
      state.visible = false;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setOpenDownloadModal: (state, action: PayloadAction<boolean>) => {
      state.openDownloadModal = action.payload;
    },
    setTemplateData: (state, action: PayloadAction<{ language: string }[] | undefined>) => {
      state.templateData = action.payload;
    },
    setPaymentData: (state, action: PayloadAction<IPaymentData | undefined>) => {
      state.paymentData = action.payload;
    }
  }
});

export const {
  setContractNumber,
  setContractId,
  setVisible,
  setClear,
  setCurrentPage,
  setOpenDownloadModal,
  setTemplateData,
  setPaymentData
} = contractSlice.actions;
export default contractSlice.reducer;
